var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotSetupYet = function SvgNotSetupYet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 23c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.01-11C5.981 1 1 5.982 1 12c0 6.007 4.993 11 11 11m-.01-8.994c-.562 0-.874-.313-.885-.884l-.14-5.878c-.011-.571.41-.981 1.013-.981.594 0 1.036.42 1.025.992l-.151 5.867c-.01.582-.324.884-.863.884m0 3.613c-.648 0-1.209-.518-1.209-1.154 0-.637.55-1.165 1.208-1.165s1.208.518 1.208 1.165-.56 1.154-1.208 1.154"
  })));
};
export default SvgNotSetupYet;